export const CATEGORIAS = 'CATEGORIAS';
